import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { DashboardInstallationColumn } from '@store';
import { KanbanColumnNamePipe } from '../kanban-column-name/kanban-column-name.pipe';

@Component({
  selector: 'app-kanban-column-drop-cover',
  templateUrl: './kanban-column-drop-cover.component.html',
  styleUrls: ['./kanban-column-drop-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, CommonModule, KanbanColumnNamePipe, TranslateModule],
})
export class KanbanColumnDropCoverComponent implements OnInit {
  @Input() column: DashboardInstallationColumn;
  @Input() idOfDraggedInstallation: number;

  isDraggedInstallationAlreadyPresent: boolean;

  constructor() {}

  ngOnInit(): void {
    if (this.column.selfDefined) {
      // TODO VIG-12305 IMPROVEMENT - iterate over array of ids
      this.isDraggedInstallationAlreadyPresent = this.column.installations.some(
        (installation) => installation.id === this.idOfDraggedInstallation
      );
    }
  }
}
